/**
 * prefilledFieldUtils — F-004 Phase 3 (IMPL-P3-002).
 *
 * Mirror strutturale di `contestedFieldUtils.ts` (F-005), ma con stile
 * **blu/info** invece di amber/errore: nessuna ambiguità cromatica tra un
 * campo "da correggere" (F-005, ring amber) e un campo "precompilato dalla
 * pratica madre" (F-004, ring blu).
 *
 * Un campo passa per due stati visivi:
 *  - "precompilato": valore ereditato dalla pratica madre, non ancora toccato
 *    dall'utente → ring blu + hint sr-only `PREFILLED_HINT_TEXT`.
 *  - "modificato": l'utente ha editato il valore (RHF `dirtyFields`) → il ring
 *    scompare, resta un badge outline/muted + hint sr-only `MODIFIED_HINT_TEXT`.
 *
 * Regola non negoziabile (Accessibility, spec): mai solo-visivo — il ring è
 * sempre accompagnato da uno `<span class="sr-only">` collegato via
 * `aria-describedby` con l'id deterministico di `prefilledHintId(path)`.
 */

/** Tailwind ring blu applicato all'input quando il path è precompilato (non ancora modificato). */
export const PREFILLED_RING_CLASS = 'ring-2 ring-blue-400 ring-offset-2';

/** Testo sr-only mostrato accanto al campo precompilato (per AT). */
export const PREFILLED_HINT_TEXT = 'Campo precompilato dalla pratica madre — modificabile';

/** Testo sr-only mostrato accanto al campo modificato rispetto al valore precompilato (per AT). */
export const MODIFIED_HINT_TEXT = 'Campo modificato rispetto al valore precompilato';

/** Etichetta breve del badge visivo per lo stato "precompilato". */
export const PREFILLED_BADGE_LABEL = 'precompilato';

/** Etichetta breve del badge visivo per lo stato "modificato". */
export const MODIFIED_BADGE_LABEL = 'modificato';

/**
 * Restituisce un id stabile per il `<span>` sr-only associato al field path
 * (es. `prefilled-hint-conduttore-codiceFiscale`). Sostituisce i punti con
 * trattini per mantenere l'id valido HTML5.
 */
export function prefilledHintId(fieldPath: string): string {
  return `prefilled-hint-${fieldPath.replace(/\./g, '-')}`;
}
